// extracted by mini-css-extract-plugin
module.exports = {"footer":"footerStyles_footer__2fPMo","gradient":"footerStyles_gradient__1IOHr"};